"use client"

import { Banner } from '@/app/components/Banner'
import ServiceContent from '@/app/components/ServiceContent'
import { mobileAppDevelopmentImg } from '@/assets/imgs'
import { useTranslations } from 'next-intl'


const MobileAppDev = () => {
  const  t  = useTranslations()
  return (
    <>
      <Banner
        subUrl={t('links.services')}
        name={t('links.mobileAppDevelopment')}
        description={t('mobileAppDevelopment.bannerDescription')}
        className='bg-mobileDevelopment'
      />
      <ServiceContent
        title={t('links.mobileAppDevelopment', )}
        header={t('mobileAppDevelopment.header', )}
        subContent={t('mobileAppDevelopment.subTitle')}
        content={t('mobileAppDevelopment.content')}
        img={mobileAppDevelopmentImg}
      />
    </>
  )
}

export default MobileAppDev
